// Palet "Pastel Bouquet" — sesuai mockup di tiket Tulip DEV-1049 (screenshot-crm-inbox-reference.png,
// screenshot-set-label.png, screenshot-chat-final-country-code.png). D-8 pada tiket itu memutuskan
// TIDAK memakai skema warna WhatsApp (hijau) — jangan kembalikan warna hijau/biru default MUI di sini.
export const PASTEL = {
    primary: "#8c5b73",
    primaryDark: "#6f4459",
    primarySoft: "#f3e3ea",
    background: "#f6ece2",
    surface: "#fffdfb",
    surfaceAlt: "#faf3ec",
    border: "#ece0d5",
    // Fix (2026-09-18) — label emas/mustard di kartu ringkasan & header tabel dashboard, sesuai
    // mockup tiket asli (AC-5). Sama persis dengan tone brand "Prestisa" di BRAND_COLORS di bawah
    // (kebetulan sama), tapi diberi token terpisah karena maknanya beda (aksen label, bukan warna brand).
    accentLabel: "#c08a2e",
    // Fix (2026-09-18) — background kotak ringkasan & header tabel di Dashboard Performa (AC-5).
    // Token TERPISAH dari `primarySoft` (dipakai luas di ChatPanel/ConversationList/dll) supaya
    // perubahan warna ini gak ikut ngubah tampilan komponen lain di luar dashboard.
    dashboardWidget: "#f3e9e3",
    // Fix (2026-09-18) — font header tabel Dashboard Performa. Token terpisah dari `accentLabel`
    // (masih dipakai buat label kotak ringkasan) karena user minta warna beda khusus header tabel.
    tableHeaderText: "#8f827b",
    // DEV-1227 — badge kesediaan self-order. Tone sage/terracotta senada palet, BUKAN
    // hijau/biru default MUI (lihat catatan D-8 di atas).
    success: "#6a8f6b",
    successSoft: "#e8efe8",
    danger: "#a1655a",
    dangerSoft: "#f3e6e3",
};

// Warna kanal per-brand meniru rail kanal di mockup (RB = mauve, Prestisa = mustard, Parselia = sage).
// Brand baru yang belum terdaftar di sini jatuh ke tone bernuansa sama lewat hash (lihat getBrandColor).
const BRAND_COLORS = {
    "Rangkaian Bunga": "#8c5b73",
    "Prestisa": "#c08a2e",
    "Parselia": "#6a8f6b",
};

const FALLBACK_BRAND_TONES = ["#8c5b73", "#c08a2e", "#6a8f6b", "#a1655a", "#6b7fa3"];

export function getBrandColor(brand = "") {
    if (BRAND_COLORS[brand]) return BRAND_COLORS[brand];
    let hash = 0;
    for (let i = 0; i < brand.length; i++) hash = brand.charCodeAt(i) + ((hash << 5) - hash);
    return FALLBACK_BRAND_TONES[Math.abs(hash) % FALLBACK_BRAND_TONES.length];
}
